import React, { useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useSessionContext } from "components/Session";
import { userAuthSetup } from "api.mjs";
import log from "loglevel";
import "sass/login.scss";
import AwaitingConfirmation from "./AwaitingConfirmation";
import ReceivedConfirmationCode from "./ReceivedConfirmationCode";
import { SwitchTransition } from "react-transition-group";
import { CSSTransition } from "react-transition-group";
import LogoEmail from "img/iconEmail.svg";
import iconEmail from "../../img/iconEmail.svg";

const EMAIL_ADDRESS_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const sendVerificationEmail = ({
  email,
  sessionContext,
  setSignUpLoading,
  setLoginState,
  setShowModal,
  setShowPopup,
  setConfirmationId,
}) => {
  const {
    location: { origin },
  } = window;

  const data = {
    type: "send-confirmation-email",
    origin,
    email,
  };

  setSignUpLoading(true);

  userAuthSetup({ data, context: { sessionContext } }).then((result) => {
    log.debug("sendVerificationEmail result", result);
    setSignUpLoading(false);
    setLoginState("awaiting-confirmation");
    setShowPopup("hide");
    setShowModal(true);
    setConfirmationId(result.confirmation_id);
  });
};

const EnterEmailForm = ({
  email,
  setEmail,
  setConfirmationId,
  setLoginState,
  setShowModal,
  setShowPopup,
}) => {
  const { sessionContext } = useSessionContext();
  const [signUpLoading, setSignUpLoading] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [validated, setValidated] = useState(false);
  const emailChangedHandler = ({ target: { value: newEmailAddress } }) => {
    setEmail(newEmailAddress);
    setIsEmailValid(EMAIL_ADDRESS_REGEX.test(newEmailAddress));
  };

  const submitLoginFormHandler = (event) => {
    log.debug(`signUpHandler:`, event);
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    log.debug("window.location", window.location);
    const {
      location: { origin },
    } = window;
    const form = event.currentTarget;
    if (form.checkValidity() && isEmailValid) {
      sendVerificationEmail({
        email,
        sessionContext,
        setSignUpLoading,
        setLoginState,
        setShowModal,
        setShowPopup,
        setConfirmationId,
      });
    }
  };

  return (
    <>
      <Form noValidate validated={validated} onSubmit={submitLoginFormHandler}>
        <div className="input-container">
          <div className="img-container">
            <img src={iconEmail} alt="icon" />
          </div>
          <input
            type="email"
            className="form-control without-focus"
            id="emailAddressField"
            aria-describedby="emailHelp"
            placeholder="Enter email"
            value={email}
            onChange={emailChangedHandler}
            required
          />
          <div className="invalid-feedback mt-2 mb-2">
            Please provide a valid email address.
          </div>
        </div>

        <div className="btn-container">
          <button
            disabled={!!signUpLoading}
            type="submit"
            className="btn-login"
          >
            {signUpLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="grow"
                  role="status"
                  aria-hidden="true"
                  size="sm"
                />
                Loading...
              </>
            ) : (
              <>Login With Email</>
            )}
          </button>
        </div>
      </Form>
    </>
  );
};

const LoginWithEmailModal = (props) => {
  const [email, setEmail] = useState("");
  const [confirmationId, setConfirmationId] = useState();
  const [confirmationCode, setConfirmationCode] = useState();
  const [showModal, setShowModal] = useState(false);
  const [loginState, setLoginState] = useState("initial");

  const handleClose = () => {
    setShowModal(false);
  };

  const subProps = {
    ...props,
    email,
    setEmail,
    confirmationId,
    setConfirmationId,
    confirmationCode,
    setConfirmationCode,
    setLoginState,
    setShowModal,
    setShowPopup: props.setShowPopup,
    onLoginSuccess: props.onLoginSuccess,
  };

  const getModalBodySubComponent = () => {
    switch (loginState) {
      case "awaiting-confirmation":
        return <AwaitingConfirmation {...subProps} />;
      case "received-confirmation-code":
        return <ReceivedConfirmationCode {...subProps} />;
      default:
        return <></>;
    }
  };

  return (
    <div className="email-login-container">
      <Modal
        show={showModal}
        onHide={handleClose}
        dialogClassName="login-with-email-modal"
        className="emailModal"
        aria-labelledby="contained-modal-title-vcenter"
        // size="lg"
        centered
        backdrop
      >
        <Modal.Body className="modal-body">
          <div className="img-container text-center">
            <img src={LogoEmail} alt="email" />
          </div>
          <div className="title">Confirm Your Email</div>
          <SwitchTransition>
            <CSSTransition
              key={loginState}
              addEndListener={(node, done) =>
                node.addEventListener("transitionend", done, false)
              }
              classNames="fade"
            >
              {getModalBodySubComponent()}
            </CSSTransition>
          </SwitchTransition>
        </Modal.Body>
      </Modal>
      <EnterEmailForm {...subProps} />
    </div>
  );
};

export default (props) => {
  return <LoginWithEmailModal {...props} />;
};
